import { Box } from '@mui/material';
import React from 'react';

import CopyableText from 'components/atoms/CopyableText';

export const CliCommandBlock = ({ command }: { command: string }) => (
  <CopyableBlock text={command} copyButtonAriaLabel="Copy command" />
);

export const CopyableBlock = ({ text, copyButtonAriaLabel }: { text: string; copyButtonAriaLabel: string }) => (
  <Box
    sx={{
      border: 1,
      borderColor: 'divider',
      borderRadius: 1,
      bgcolor: 'background.default',
      overflow: 'hidden',
    }}
  >
    <CopyableText
      copyWithButton="right"
      copyButtonVisibility="always"
      textForCopy={text}
      tooltipText="Copy"
      component="code"
      variant="body2"
      whiteSpace="pre-wrap"
      sx={{
        cursor: 'copy',
        display: 'block',
        fontFamily: 'monospace',
        lineHeight: 1.6,
        overflowX: 'auto',
        p: 1,
        textOverflow: 'clip',
        wordBreak: 'break-word',
      }}
      copyButtonProps={{ size: 'small', 'aria-label': copyButtonAriaLabel }}
      copyIconProps={{ fontSize: 'small' }}
    >
      {text}
    </CopyableText>
  </Box>
);
